module.exports = __webpack_public_path__ + "static/media/攻击性语言检测（英语）.2e97e94e.png";